import { useContext, useState } from "react";
import { FiBell, FiCheckCircle, FiClock } from "react-icons/fi";
import { useGlobalContext } from "../../../Context/GlobalContext";
import { FaRegCheckCircle } from "react-icons/fa";
import axios from "axios";
import { getCurrentDate } from "../../../Utilitie";
import FailedMsg from "../../../Extra/FailedMsg";
import SuccessMsg from "../../../Extra/SuccessMsg";

const urlPrefix = process.env.REACT_APP_URL_PREFIX;
export function ReminderPanel({ reminders, onView, loadMessages }) {
  const [show, setShow] = useState(false);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const { userData } = useGlobalContext();
  const formatDate = (value) => {
    if (!value) return "—";

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "—";

    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  const updateRemainder = async (data) => {
    setLoading(false);
    setShow(false);
    let response;
    try {
      response = await axios.put(
        `${urlPrefix}msg/update_messages/${data.id}
`,
        {
          reminder_action: `Reminded (Reminded by ${userData.id} at ${getCurrentDate()} )`,
        },
      );
      setResult({
        success: true,
        message: response.data?.message || "Message updated successfully.",
      });

      setShow(true);
      loadMessages();
    } catch (error) {
      console.error("Submission error:", error);

      setResult({
        success: false,
        message:
          error?.response?.data?.message ||
          error?.message ||
          "Failed to update Reminded.",
      });

      setShow(true);
    } finally {
      setLoading(false);
    }
  };
  const handleCheck = (data) => {
    if (data) {
      const confirmCheck = window.confirm(
        "Are you sure you want to update the reminder for this message ?",
      );

      if (confirmCheck) {
        updateRemainder(data);
        // Call your function here
        // yourFunction();
      }
    }
  };
  return (
    <div className="card border-0 shadow-sm h-100" style={{ borderRadius: 14 }}>
      <div className="card-body p-3 p-md-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h6 className="fw-bold mb-1">Reminder alerts</h6>
            <div className="small text-secondary">
              Overdue, due today, and upcoming
            </div>
          </div>
          <FiBell size={22} color="#dc3545" />
        </div>

        {reminders.length === 0 ? (
          <div className="text-center py-4">
            <FiCheckCircle size={30} color="#087344" />
            <p className="fw-semibold mt-2 mb-1">All clear</p>
            <p className="small text-secondary mb-0">
              No reminders are due within the next 3 days.
            </p>
          </div>
        ) : (
          <div className="d-flex flex-column gap-2">
            {reminders
              .filter((f) => f.reminder_action === null)
              .slice(0, 5)
              .map((item) => (
                <div
                  key={item.id}
                  className="d-flex gap-2 align-items-start p-2 rounded-3"
                  style={{
                    background: `${item.reminderStatus.color}0D`,
                    border: `1px solid ${item.reminderStatus.color}25`,
                  }}
                >
                  <FiClock
                    className="mt-1 flex-shrink-0"
                    color={item.reminderStatus.color}
                  />

                  <div className="flex-grow-1 min-w-0">
                    <div
                      className="fw-semibold small text-truncate"
                      title={item.subject}
                    >
                      {item.subject || "Untitled message"}
                    </div>
                    <div className="small text-secondary">
                      {formatDate(item.reminder_date)}
                    </div>

                    <span
                      className="small fw-semibold"
                      style={{ color: item.reminderStatus.color }}
                    >
                      {item.reminderStatus.label}
                    </span>
                  </div>
                  <div className="d-flex align-items-center">
                    <button
                      className="btn btn-sm btn-outline-primary flex-shrink-0"
                      onClick={() => onView(item.id)}
                      type="button"
                    >
                      View
                    </button>
                    {(userData.accessRight
                      .split(",")
                      .includes("MessagingMaster") ||
                      userData.role === "admin") && (
                      <div className="ms-2">
                        <span
                          className="text-secondary"
                          style={{ fontSize: "12px" }}
                        >
                          Reminded
                        </span>
                        <br />
                        <button
                          className="btn btn-sm btn-outline-success flex-shrink-0"
                          type="button"
                          onClick={() => handleCheck(item)}
                        >
                          <FaRegCheckCircle />
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              ))}

            {reminders.length > 5 && (
              <div className="small text-secondary text-center mt-1">
                +{reminders.length - 5} more reminders in the filtered list
              </div>
            )}
          </div>
        )}
      </div>
      <div className="p-3">
        {result?.success ? (
          <SuccessMsg
            type="Success"
            message={result.message}
            show={show}
            setShow={setShow}
          />
        ) : result ? (
          <FailedMsg
            type="Failed"
            message={result.message}
            show={show}
            setShow={setShow}
          />
        ) : null}
      </div>
    </div>
  );
}
